<script>
import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {required, minValue} from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import {helpers} from "../../../../helpers/helpers-validate";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Procesar venta",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    // PageHeader,
    // DatePicker,
    // Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      formFactura: {
        validate: false,
        validateButton: true,
        idVenta: 0,
        nit: "",
        nombre: "",
        direccion: ""
      },
      validateSaldo: false,
      saldoEgreso: 0.0,
      buttonSaldo: false,
      temporal_saldo: "",
      saldo_total: "",
      saldo_restante: "",
      validateCaja: false,
      idCaja: "",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      arraySaveProductos: [],
      arraySaveServicios: [],
      arrayProductos: [],
      producto: "",
      arrayServicios: [],
      servicio: "",
      busquedaLabel: {nombre: "Código", value: "codigo"},
      busquedaLabel2: {nombre: "Nombre", value: "nombre"},
      busquedaTipos: [
        {nombre: "Código", value: "codigo"},
        {nombre: "Nombre", value: "producto"},
      ],
      busquedaTipos2: [{nombre: "Nombre", value: "nombre"}],
      fieldsProductos: [
        {key: "action", label: "Acciones"},
        {key: "codigo", label: "Código"},
        {key: "producto", label: "Producto"},
        {key: "existencia", label: "Existencia"},
        {key: "departamento", label: "Departamento"},
        {key: "estante", label: "Estante"},
        {key: "precio_venta", label: "Precio venta"},
      ],
      fieldsServicios: [
        {key: "action", label: "Acciones"},
        {key: "nombre_servicio", label: "Servicio"},
        {key: "descripcion_servicio", label: "Descripción"},
      ],
      // Variables para metodos de pago
      bandera: false,
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
      // variables nuevas
      fechaVec: "",
      toggleNit: false,
      switchCliente: true,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_proveedor: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        saldo: 0,
        id: 0,
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      // Otros datos
      detalleorden: [],
      arrayVenta: [],
      arrayVentas: [],
      arrayCliente: [],
      arrayClientes: [],
      arrayDepa: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
          process.env.VUE_APP_URL +
          "productos/stock/busqueda?departamento=" +
          0 +
          "&estante=" +
          0,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      arrayEgresos: [],
      formEgreso: {
        cantidad: "",
        razon: "",
      },
      formPro: {
        fecha_venta: "",
        fecha_hoy: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        venta: null,
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          porcentaje_venta: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "PROCESAR VENTA",
      items: [
        {
          text: "Cotizaciones",
          href: "/",
        },
        {
          text: "Editar cotización",
          active: true,
        },
      ],
      searchType: [
        {nombre: "Producto", value: "producto"},
        {nombre: "Codigo", value: "codigo"},
      ],
      searchType2: [{nombre: "Nombre", value: "nombre"}],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },

      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
    };
  },
  validations: {
    formFactura: {
      // validate: {required},
      nit: {required},
      // nombre: {required},
      // direccion: {required}
    },
    formCliente: {
      nombre: {required},
      apellido: {required},
      nit: {nit, required},
      direccion: {required},
      telefono: {required},
      correo: {correo, required},
      cui: {required},
      sexo: {required},
      compania: {required},
      direc: {required},
      telefono_proveedor: {required},
    },
    formPro: {
      fecha_venta: {required},
      tienda: {required},
      cliente: {required},
      venta: {required},
      total: {required},
    },
    // data: { required },
    // Validaciones metodos de pago
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
    transferencia: {
      required,
      $each: {
        cantidad_transferencia: {
          required,
          // minValue: minValue(1),
        },
        transaccion_transferencia: {
          required,
        },
      },
    },
    deposito: {
      required,
      $each: {
        cantidad_deposito: {
          required,
          // minValue: minValue(1),
        },
        transaccion_deposito: {
          required,
        },
      },
    },
    cheque: {
      required,
      $each: {
        cantidad_cheque: {
          required,
          // minValue: minValue(1),
        },
        transaccion_cheque: {
          required,
        },
      },
    },
    tarjeta: {
      required,
      $each: {
        cantidad_tarjeta: {
          required,
          // minValue: minValue(1),
        },
        transaccion_tarjeta: {
          required,
        },
      },
    },
    montoFinal: {
      cantidad: {
        minValue: minValue(1),
      },
    },
    formEgreso: {
      cantidad: {required},
      razon: {required},
    },
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
    if (this.$route.params.id > 0) {
      // console.log(this.$route.params.id);
      await this.getIdVenta();
    }
    await this.validarCaja();
    // await this.getEgresos();
    await this.gettienda();
    await this.getClientes();
    await this.getVentas();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let resultado = 0.0;
      if (this.detalleorden.length > 0) {
        for (let i = 0; i < this.detalleorden.length; i++) {
          resultado = resultado + parseFloat(this.detalleorden[i].subtotal);
        }
      }
      if (this.buttonSaldo == true) {
        let temp = resultado - this.temporal_saldo;
        if (Math.sign(temp) == -1) {
          resultado = 0;
        } else {
          resultado = resultado - this.temporal_saldo;
        }
      }
      return resultado.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    optionFacturar(tipo) {
      if (tipo == 1) {
        this.formFactura.validate = true;
      } else {
        this.$bvModal.hide("modalNIT");
        this.$router.push({
            name: "imprimirProcesada",
            params: {id: this.formFactura.idVenta},
          });
        this.resetAll();
        // this.showModal = false;
      }
    },
    validateFacturar(cf) {
      if (cf==2){
        this.formFactura.nit="CF"
      }
      const {nit, nombre, direccion} = this.formFactura
      if (nit === "" || (nombre === ""&&nit!="CF") || (direccion === ""&&nit!="CF")) {
        Vue.toasted.error("Los datos para facturar son inválidos", this.options);
        return;
      }
      this.facturar();
    },
    validateNIT() {
      if (this.formPro.cliente) {
        if (this.formPro.cliente.nit_cliente != 'C/F'&&this.formPro.cliente.nit_cliente != 'CF') {
          this.formFactura.nit = this.formPro.cliente.nit_cliente;
          this.searchNIT();
        }
        else{
          this.formFactura.nit = this.formPro.cliente.nit_cliente;  
          Vue.toasted.success("Consumidor Final", this.options);  
          this.formFactura.validateButton = false;
          this.showModalL = false;
        }
      }
    },
    async searchNIT() {
      try {
        this.showModalL = true;
        const response = await axios
            .get(`https://freyja-dev.totaldoc.io/api/nit/${this.formFactura.nit}`, {
              headers: {"appKey": "30f80c7e8d5c793cf3585a754ae44ef9e0f1ace376a5ccaa936daf6ab3c8537b1bf12160641a9b706998fa31abda0900b4b89236286bbee7d187d4f305cc552c"},
            });
        // console.log(response);
        if (response.data.message == "OK") {
          this.formFactura.validateButton = false;
          this.formFactura.nombre = response.data.name;
          this.formFactura.direccion = response.data.address;
          this.showModalL = false;
          Vue.toasted.success("NIT válido", this.options);
        } else {
          Vue.toasted.error("NIT inválido", this.options);
          this.showModalL = false;
        }
      } catch (error) {
        console.log(error);
        Vue.toasted.error("NIT inválido", this.options);
        this.showModalL = false;
      }
    },

    async facturar() {
      try {
        this.showModalL = true;
        const response = await axios
            .post(this.apiUrl+`facturacion/generarFel`,
                {
                  "nit": this.formFactura.nit? this.formFactura.nit:"CF",
                  "nombre":   this.formFactura.nombre?this.formFactura.nombre:this.formPro.cliente.nombre,
                  "correo": this.formPro.cliente.email? this.formPro.cliente.email:"",
                  "direccion":  this.formFactura.direccion? this.formFactura.direccion:"Ciudad",
                  "id": this.formFactura.idVenta
                },
                 {headers:{ "x-token": this.$store.state.authfack.user.token,  'Content-Type': 'application/json', 
                  'Access-Control-Allow-Origin':'*' }},
               );
        if (response.status == 200) {
          this.showModalL = false;
          console.log(response)
          this.$bvModal.hide("modalNIT");
          this.$router.push({
            name: "imprimirProcesada",
            params: {id: this.formFactura.idVenta},
          });
          this.resetAll();
        } else {
          this.$bvModal.hide("modalNIT");
          Vue.toasted.error("Ocurrió un error", this.options);
          this.showModalL = false;
        }
      } catch (error) {
        console.log(error);
        this.$bvModal.hide("modalNIT");
        Vue.toasted.error("Ocurrió un error", this.options);
        this.showModalL = false;
      }
    },
    inicioRapido() {
      let me = this;
      axios
          .post(
              process.env.VUE_APP_URL + "caja/store",
              {
                inicio_caja: 0,
                observacion: "Inicio de caja rápido " + this.showHour(new Date()),
                usuario: me.userT.id,
              },
              {
                headers: {"x-token": me.userT.token},
              }
          )
          .then(() => {
            Vue.toasted.success("Inicio de caja rápido realizado", me.options);
            me.validarCaja();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    async validarCaja() {
      let me = this;
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL +
            "caja/get_validate?" +
            "&usuario=" +
            this.userT.id,
            {
              headers: {"x-token": this.userT.token},
            }
        );
        if (response.data.validate) {
          me.idCaja = response.data.validate.id;
          me.$bvModal.hide("modalValidacion");
          return;
        }
        me.$bvModal.show("modalValidacion");
      } catch (error) {
        console.log(error);
      }
    },
    validarExistencia(data) {
      axios
          .get(
              process.env.VUE_APP_URL +
              "productos/existencia_actual?id=" +
              data.idProducto +
              "&tipo=1",
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            // console.log(data.cantidad, response);
            const existencia = response.data.existencia_disponible;
            if (data.cantidad > existencia) {
              Vue.toasted.error(
                  `La existencia del producto < ${data.descripcion} > es de ${existencia} unidades`,
                  this.options
              );
              data.existencia = true;
              if (existencia > 1) {
                data.cantidad = 1;
              } else {
                data.cantidad = 0;
              }
            } else {
              data.existencia = false;
            }
          });
    },
    changeSubtotal(index) {
      this.buttonSaldo = false;
      this.saldo_total = this.temporal_saldo;
      this.detalleorden[index].subtotal =
          (this.detalleorden[index].cantidad != ""
              ? parseFloat(this.detalleorden[index].cantidad)
              : 0.0) *
          (this.detalleorden[index].valor_unitario != ""
              ? parseFloat(this.detalleorden[index].valor_unitario)
              : 0.0);
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.cantidad_efectivo = "";
        this.sumarCantidades();
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.transferencia = [
          {
            cantidad_transferencia: "",
            transaccion_transferencia: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "deposito" && !this.checkMoney.deposito) {
        this.deposito = [
          {
            cantidad_deposito: "",
            transaccion_deposito: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.cheque = [
          {
            cantidad_cheque: "",
            transaccion_cheque: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "tarjeta" && !this.checkMoney.tarjeta) {
        this.cheque = [
          {
            cantidad_tarjeta: "",
            transaccion_tarjeta: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
    },
    sumarCantidades() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      let sum4 = 0;
      let sum5 = 0;

      if (this.checkMoney.efectivo) {
        sum =
            parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo)) > 0
                ? parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo))
                : 0;
        // this.validarCantidades.efectivo = sum;
      }

      if (this.checkMoney.transferencia) {
        for (let i = 0; i < this.transferencia.length; i++) {
          sum2 =
              sum2 +
              (parseFloat(
                  this.converMaskToNumberxd(
                      this.transferencia[i].cantidad_transferencia
                  )
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(
                          this.transferencia[i].cantidad_transferencia
                      )
                  )
                  : 0);
        }
      }

      if (this.checkMoney.deposito) {
        for (let i = 0; i < this.deposito.length; i++) {
          sum3 =
              sum3 +
              (parseFloat(
                  this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
                  )
                  : 0);
        }
      }

      if (this.checkMoney.cheque) {
        for (let i = 0; i < this.cheque.length; i++) {
          sum4 =
              sum4 +
              (parseFloat(
                  this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                  )
                  : 0);
        }
      }

      if (this.checkMoney.tarjeta) {
        for (let i = 0; i < this.tarjeta.length; i++) {
          sum5 =
              sum5 +
              (parseFloat(
                  this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
              ) > 0
                  ? parseFloat(
                      this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
                  )
                  : 0);
        }
      }
      this.montoFinal.cantidad = sum + sum2 + sum3 + sum4 + sum5;
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
        case "egresos": {
          this.$v.$reset();
          this.formEgreso = {
            cantidad: "",
            razon: "",
          };
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formCliente.id = 0;
      this.formCliente.telefono_proveedor = "";
      this.formCliente.correo = "";
      this.formCliente.cui = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "";
      this.formCliente.direccion = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    asignarSaldo() {
     // console.log('aquiii');
      if (this.formPro.cliente) {
        // console.log(this.formPro.cliente);
        let saldo = parseFloat(this.formPro.cliente.cuenta_clientes[0].saldo);
        console.log('saldo',saldo);
        this.saldo_total = saldo ? saldo : 0;
        this.temporal_saldo = saldo ? saldo : 0;
      } else {
        this.saldo_total = "";
        this.temporal_saldo = "";
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
      if (action == "saldo") {
        if (this.temporal_saldo > 0) {
          if (this.buttonSaldo == true) {
            this.buttonSaldo = false;
            this.saldo_total = this.temporal_saldo;
          } else {
            if (this.formPro.total > 0 && this.formPro.total != "") {
              let saldo_temp = "";
              this.buttonSaldo = true;
              saldo_temp =
                  parseFloat(this.formPro.total) - parseFloat(this.saldo_total);
              if (Math.sign(saldo_temp) == -1) {
                this.saldo_total = saldo_temp * -1;
                this.saldo_restante = this.temporal_saldo - this.saldo_total;
              } else {
                this.saldo_restante = this.formPro.total - saldo_temp;
                this.saldo_total = 0;
              }
            } else {
              Vue.toasted.error(
                  "El total debe sey mayor a cero para asignar saldo",
                  this.options
              );
            }
          }
        } else {
          Vue.toasted.error("No cuenta con saldo disponible", this.options);
        }
      }
    },
    onButton(action, index) {
      if (action == "transferencia-plus") {
        this.transferencia.push({
          transaccion_transferencia: "",
          cantidad_transferencia: "",
          button: false,
        });
      }
      if (action == "transferencia-minus") {
        this.transferencia.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "deposito-plus") {
        this.deposito.push({
          transaccion_deposito: "",
          cantidad_deposito: "",
          button: false,
        });
      }
      if (action == "deposito-minus") {
        this.deposito.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "cheque-plus") {
        this.cheque.push({
          transaccion_cheque: "",
          cantidad_cheque: "",
          button: false,
        });
      }
      if (action == "cheque-minus") {
        this.cheque.splice(index, 1);
        this.sumarCantidades();
      }

      if (action == "tarjeta-plus") {
        this.tarjeta.push({
          transaccion_tarjeta: "",
          cantidad_tarjeta: "",
          button: false,
        });
      }
      if (action == "tarjeta-minus") {
        this.tarjeta.splice(index, 1);
        this.sumarCantidades();
      }
    },
    getDatosCliente() {
      this.cambioApiBase();
    },
    resetAll() {
      this.getVentas();
      this.detalleorden = [];
      this.formPro.venta = null;
      this.formPro.cliente = null;
      this.formPro.total = "";
      this.formPro.fecha_venta = "";
      this.formPro.observaciones = "";
      // this.formPro.tienda = "";
      this.buttonSaldo = false;
      this.saldo_total = "";
      this.saldo_restante = "";
      this.temporal_saldo = "";
      this.bandera = false;
      this.cantidad_efectivo = "";
      this.transferencia = [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ];
      this.deposito = [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ];
      this.cheque = [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ];
      this.tarjeta = [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ];
      this.checkMoney = {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      };
      this.checkSelect = {
        efectivo: false,
        deposito: false,
        cheque: false,
        transferencia: false,
        tarjeta: false,
      };
      this.montoFinal = {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      };
      this.montos = {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      };

      this.formFactura = {
        validate: false,
        validateButton: true,
        idVenta: 0,
        nit: "",
        nombre: "",
        direccion: ""
      };
    },
    selectVenta(valor) {
      if (valor == null) {
        this.resetAll();
      } else {
        let producto = valor.detalle_ventas;
        let servicio = valor.detalle_servicio_vs;
        this.detalleorden = [];

        for (let i = 0; i < producto.length; i++) {
          this.detalleorden.push({
            origen: producto[i],
            cantidad: producto[i].cantidad_venta,
            descripcion:
                producto[i].stock.producto.nombre_producto +
                (producto[i].stock.producto.descripcion_producto == null ||
                producto[i].stock.producto.descripcion_producto == ""
                    ? ""
                    : " - " + producto[i].stock.producto.descripcion_producto),
            valor_original: producto[i].precio_original,
            valor_unitario: producto[i].precio_venta,
            porcentaje: producto[i].descuento_porcentaje,
            subtotal: producto[i].subtotal_venta,
            idProducto: producto[i].detalleDepartamentoId,
            idServicio: "",
            tipo: 1,
            existencia: false,
          });
          axios
              .get(
                  process.env.VUE_APP_URL +
                  "productos/existencia_actual?id=" +
                  producto[i].detalleDepartamentoId +
                  "&tipo=1",
                  {
                    headers: {"x-token": this.userT.token},
                  }
              )
              .then((response) => {
                const existencia = response.data.existencia_disponible;
                if (producto[i].cantidad_venta > existencia) {
                  this.detalleorden[i].existencia = true;
                }
              });
        }

        for (let i = 0; i < servicio.length; i++) {
          this.detalleorden.push({
            origen: servicio[i],
            cantidad: servicio[i].cantidad_servicios,
            descripcion:
                servicio[i].servicio.nombre_servicio +
                (servicio[i].servicio.descripcion_servicio == "" ||
                servicio[i].servicio.descripcion_servicio == null
                    ? ""
                    : " - " + servicio[i].servicio.descripcion_servicio),
            valor_unitario: servicio[i].precio_servicio,
            subtotal: servicio[i].subtotal_servicio,
            idProducto: "",
            idServicio: servicio[i].servicioId,
            tipo: 0,
          });
        }

        if (valor.cliente != null) {
          console.log("cliente",valor.cliente.persona)
          this.formPro.cliente = valor.cliente;
          this.formPro.cliente.email =
              valor.cliente.persona.email_persona;
              this.formFactura.direccion=valor.cliente.persona.direccion_persona;
              this.formFactura.nombre=valor.cliente.persona.nombre_persona;
          this.formPro.cliente.nombre =
              valor.cliente.persona.nombre_persona +
              " | " +
              valor.cliente.nit_cliente;
        } else {
          this.formPro.cliente = null
        }
        console.log("formpro",this.formPro)
        // console.log(valor);
        this.formPro.total =
            valor.estado_cuenta == true
                ? parseFloat(valor.pago_cuenta) + parseFloat(valor.total)
                : valor.total;
        this.formPro.fecha_venta = valor.fecha_venta;
        this.formPro.observaciones = valor.observaciones;
       // this.asignarSaldo();
        // this.formPro.tienda = valor.tienda.nombre_tienda;
      }
      console.log(this.detalleorden)
    },
    async selectCliente(valor) {
      this.arrayCliente = [];
      for (var i = 0; i < this.arrayClientes.length; i++) {
        const estado = this.arrayClientes[i].nombre
            .toLowerCase()
            .includes(valor.toLowerCase());
        if (estado === true) {
          this.arrayCliente.push(this.arrayClientes[i]);
        }
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";
      axios
          .get(process.env.VUE_APP_URL + "tiendas/select", {
            headers: {"x-token": this.userT.token},
          })
          .then(function (response) {
            me.formPro.tienda = response.data[0].nombre_tienda;
            me.formPro.tiendaid = response.data[0].id;
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    swNit() {
      if (!this.toggleNit) {
        this.formCliente.nit = "CF";
      }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      this.$v.formCliente.telefono_proveedor.$touch();
      let telC = 0;
      let {nombre, telefono_proveedor} = this.formCliente;

      for (let i = 0; i < telefono_proveedor.length; i++) {
        if (telefono_proveedor[i] == "_" || telefono_proveedor[i] == "") {
          telC++;
        }
      }
      if (nombre == "" || telC > 0) {
        Vue.toasted.error("Complete los datos del cliente", this.options);
        return;
      }
      this.showModalL = true;
      if (opc == "save") {
        this.saveCliente();
      }
      if (opc == "update") {
        this.update();
      }
    },
    validacionesVenta() {
      this.$v.$touch();
      let a = 0;
      for (let i = 0; i < this.detalleorden.length; i++) {
        if (parseFloat(this.detalleorden[i].subtotal) == 0) a++;
      }

      if (
          this.formPro.venta != null &&
          this.formPro.cliente != null &&
          a == 0
      ) {
        if (this.buttonSaldo == true && this.formPro.total == 0) {
          this.save();
        } else {
          if (this.montoFinal.cantidad > 0) {
            if (
                this.checkMoney.efectivo ||
                this.checkMoney.transferencia ||
                this.checkMoney.deposito ||
                this.checkMoney.cheque ||
                this.checkMoney.tarjeta
            ) {
              this.bandera = false;
              if (this.checkMoney.efectivo) {
                if (this.converMaskToNumberxd(this.cantidad_efectivo) == "") {
                  this.bandera = true;
                  Vue.toasted.error("Agregue monto en efectivo", this.options);
                } else {
                  this.montos.monto_efectivo = parseFloat(
                      this.converMaskToNumberxd(this.cantidad_efectivo)
                  );
                }
              }
              if (this.checkMoney.transferencia) {
                let temp = 0;
                for (let i = 0; i < this.transferencia.length; i++) {
                  if (
                      this.transferencia[i].cantidad_transferencia == "" ||
                      this.transferencia[i].transaccion_transferencia == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                      "Complete campos de transferencia",
                      this.options
                  );
                } else {
                  this.montos.monto_transferencia = [];
                  for (let i = 0; i < this.transferencia.length; i++) {
                    this.montos.monto_transferencia.push({
                      monto_transferencia: parseFloat(
                          this.converMaskToNumberxd(
                              this.transferencia[i].cantidad_transferencia
                          )
                      ),
                      transaccion_transferencia:
                      this.transferencia[i].transaccion_transferencia,
                    });
                  }
                }
              }
              if (this.checkMoney.deposito) {
                let temp = 0;
                for (let i = 0; i < this.deposito.length; i++) {
                  if (
                      this.deposito[i].cantidad_deposito == "" ||
                      this.deposito[i].transaccion_deposito == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                      "Complete campos de deposito",
                      this.options
                  );
                } else {
                  this.montos.monto_deposito = [];
                  for (let i = 0; i < this.deposito.length; i++) {
                    this.montos.monto_deposito.push({
                      monto_deposito: parseFloat(
                          this.converMaskToNumberxd(
                              this.deposito[i].cantidad_deposito
                          )
                      ),
                      transaccion_deposito:
                      this.deposito[i].transaccion_deposito,
                    });
                  }
                }
              }
              if (this.checkMoney.cheque) {
                let temp = 0;
                for (let i = 0; i < this.cheque.length; i++) {
                  if (
                      this.cheque[i].cantidad_cheque == "" ||
                      this.cheque[i].transaccion_cheque == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de cheque", this.options);
                } else {
                  this.montos.monto_cheque = [];
                  for (let i = 0; i < this.cheque.length; i++) {
                    this.montos.monto_cheque.push({
                      monto_cheque: parseFloat(
                          this.converMaskToNumberxd(
                              this.cheque[i].cantidad_cheque
                          )
                      ),
                      transaccion_cheque: this.cheque[i].transaccion_cheque,
                    });
                  }
                }
              }
              if (this.checkMoney.tarjeta) {
                let temp = 0;
                for (let i = 0; i < this.tarjeta.length; i++) {
                  if (
                      this.tarjeta[i].cantidad_tarjeta == "" ||
                      this.tarjeta[i].transaccion_tarjeta == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de tarjeta", this.options);
                } else {
                  this.montos.monto_tarjeta = [];
                  for (let i = 0; i < this.tarjeta.length; i++) {
                    this.montos.monto_tarjeta.push({
                      monto_tarjeta: parseFloat(
                          this.converMaskToNumberxd(
                              this.tarjeta[i].cantidad_tarjeta
                          )
                      ),
                      transaccion_tarjeta: this.tarjeta[i].transaccion_tarjeta,
                    });
                  }
                }
              }
              if (this.bandera == false) {
                if (this.montoFinal.cantidad == this.formPro.total) {
                  this.showModalL = true;
                  this.save();
                } else {
                  Vue.toasted.error(
                      `La cantidad actual no coincide con el monto a pagar. La diferencia es de <strong>${this.formatQuetzales(
                          this.montoFinal.cantidad - this.formPro.total
                      )}</strong>`,
                      this.options
                  );
                }
              } else {
                Vue.toasted.error(
                    "Ingrese cantidades en los métodos de pago",
                    this.options
                );
              }
            } else {
              Vue.toasted.error(
                  "Seleccione al menos un método de pago",
                  this.options
              );
            }
          } else {
            Vue.toasted.error("Agregue métodos de pago", this.options);
          }
        }
      } else {
        if (a > 0) {
          Vue.toasted.error(
              "Debe agregar cantidad y valor unitario a los detalles",
              this.options
          );
          return;
        }
        Vue.toasted.error("Complete los campos", this.options);
      }
    },
    //Guardar registro
    save() {
      let me = this;
      const {cliente, tiendaid} = this.formPro;
      let totalP = 0;
      let totalS = 0;
      let datos = [];
      let datos2 = [];
      for (let i = 0; i < this.detalleorden.length; i++) {
        if (this.detalleorden[i].tipo == 1) {
          totalP = totalP + parseFloat(this.detalleorden[i].subtotal);
          datos.push({
            cantidad: this.detalleorden[i].cantidad
                ? this.detalleorden[i].cantidad
                : this.detalleorden[i].cantidad_venta,
            precio_compra: this.detalleorden[i].origen.Stock
                ? parseFloat(
                    this.detalleorden[i].origen.Stock.precio_compra_stock
                )
                : parseFloat(
                    this.detalleorden[i].origen.stock.precio_compra_stock
                ),
            precio_venta: parseFloat(this.detalleorden[i].valor_unitario),
            precio_original: parseFloat(this.detalleorden[i].valor_original),
            subtotal: parseFloat(this.detalleorden[i].subtotal),
            presentacionId: this.detalleorden[i].origen.presentacioneId
                ? this.detalleorden[i].origen.presentacioneId
                : this.detalleorden[i].origen.Stock.presentacioneId,
            porcentaje: parseFloat(this.detalleorden[i].porcentaje),
            detalle: this.detalleorden[i].origen.detalleDepartamentoId
                ? this.detalleorden[i].origen.detalleDepartamentoId
                : this.detalleorden[i].origen.id,
            id: this.detalleorden[i].origen.stockId,
          });
        }
        if (this.detalleorden[i].tipo == 0) {
          totalS = totalS + parseFloat(this.detalleorden[i].subtotal);
          datos2.push({
            cantidad: this.detalleorden[i].cantidad,
            precio_venta: parseFloat(this.detalleorden[i].valor_unitario),
            subtotal: parseFloat(this.detalleorden[i].subtotal),
            id: this.detalleorden[i].idServicio,
          });
        }
      }

      // console.log('data', datos, 'data2', datos2, totalP, totalS)

      axios
          .post(
              process.env.VUE_APP_URL + "ventas/pagar_venta",
              {
                bandera_cuenta: this.buttonSaldo,
                monto: this.saldo_restante,
                data: datos,
                data2: datos2,
                total_productos: totalP,
                total_servicios: totalS,
                total: this.formPro.total,
                id_venta: this.formPro.venta.id,
                usuario: this.userT.id,
                cliente: cliente.id,
                tienda: tiendaid,
                montos: this.montos,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            // console.log('resp', response.data.venta); // Id
            me.formFactura.idVenta = response.data.venta;
            Vue.toasted.success("Venta procesada", this.options);
            me.showModalL = false;
            // me.resetAll();
            me.$refs["modalNIT"].show();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {
      //   this.showModalL = false;
      //   this.$router.push({
      //     name: "ventas",
      //     shallow: true,
      //   });
      // });
    },
    saveCliente() {
      const {nombre, nit, direccion, telefono_proveedor, correo, cui} =
          this.formCliente;
      const me = this;
      axios
          .post(
              process.env.VUE_APP_URL + "clientes/store",
              {
                nombre,
                nit,
                direccion,
                numero: telefono_proveedor,
                email: correo,
                cui,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            Vue.toasted.success(nombre + " Guardado", this.options);
            me.formPro.cliente = response.data.clientes[0];
            me.getClientes();
            // me.$refs.vuetable.refresh();
            me.showModalN = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            me.showModalL = false;
          });
    },
    eliminarDetalleEgreso(idx) {
      // this.detalleorden.splice(idx, 1);
      let me = this;
      axios
          .put(
              process.env.VUE_APP_URL + "egresos/desactivate",
              {
                id: me.arrayEgresos[idx].id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            me.getEgresos();
            Vue.toasted.error("Egreso anulado", me.options);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    editarDetalleEgreso(idx) {
      let me = this;
      axios
          .put(
              process.env.VUE_APP_URL + "egresos/update",
              {
                id: this.arrayEgresos[idx].id,
                monto: parseFloat(this.arrayEgresos[idx].monto),
                razon: this.arrayEgresos[idx].razon,
            
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            me.getEgresos();
            Vue.toasted.success("Egreso editado", me.options);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    getSaldo() {
      let me = this;
      axios
          .post(
              process.env.VUE_APP_URL + "caja/get_valida_saldo",
              {
                id: this.idCaja,
                usuario: this.userT.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            me.saldoEgreso = response.data.saldo;

          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
          });
    },
    validateSaldoEgreso() {
      this.$v.formEgreso.$touch();
      const {cantidad, razon} = this.formEgreso;

      if (cantidad == "" || razon == "") {
        Vue.toasted.error(
            "Complete los campos para sacar dinero",
            this.options
        );
        return;
      }

      if (parseFloat(this.formEgreso.cantidad) <= 0) {
        // this.validateSaldo = true;
        Vue.toasted.error("La cantidad debe ser mayor a cero (0)", this.options);
        return;
      }
      // this.getSaldo();

      if (parseFloat(this.formEgreso.cantidad) > parseFloat(this.saldoEgreso)) {
        this.validateSaldo = true;
        Vue.toasted.error("La cantidad excede el saldo disponible", this.options);
        return;
      }

      this.validateSaldo = false;
      this.saveEgreso();
    },
    saveEgreso() {
      let me = this;
      axios
          .post(
              process.env.VUE_APP_URL + "egresos/store",
              {
                monto: parseFloat(
                    this.converMaskToNumberxd(this.formEgreso.cantidad)
                ),
                razon: this.formEgreso.razon,
                cierre: this.idCaja,
                usuario: this.userT.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            me.$v.$reset();
            me.formEgreso = {
              cantidad: "",
              razon: "",
            };
            // me.getEgresos();
            me.$bvModal.hide("modalMostrarEgresos");
            Vue.toasted.success("Egreso guardado", me.options);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
            number.charAt(i) === "Q" ||
            number.charAt(i) === "€" ||
            number.charAt(i) === "$" ||
            number.charAt(i) === "%" ||
            number.charAt(i) === "," ||
            number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
          formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    verificarstock(stock) {
      if (this.encuentra(stock["id"].toString())) {
        return true;
      }
    },
    verificarServicio(stock) {
      if (this.encuentra2(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.detalleorden.length; i++) {
        if (this.detalleorden[i].idProducto.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    encuentra2(id) {
      let sw = 0;
      for (var i = 0; i < this.detalleorden.length; i++) {
        if (this.detalleorden[i].idServicio.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    agregarDetalle(data) {
      // console.log(data);
      if (data.existencia_departamento < 1) {
        Vue.toasted.error(
            "No se puede agregar un producto con existencia cero (0)",
            this.options
        );
        return;
      }
      this.detalleorden.push({
        origen: data,
        cantidad: 1,
        descripcion:
            data.Stock.producto.nombre_producto +
            (data.Stock.producto.descripcion_producto == null ||
            data.Stock.producto.descripcion_producto == ""
                ? ""
                : " - " + data.Stock.producto.descripcion_producto),
        imagen_stock: data.Stock.imagen_stock,
        valor_unitario: data.Stock.precio_venta_stock,
        subtotal: data.Stock.precio_venta_stock,
        idProducto: data.id,
        idServicio: "",
        tipo: 1,
      });
      this.producto = "";
    },
    agregarDetalleServicio(data) {
      this.detalleorden.push({
        origen: data,
        cantidad: 1,
        descripcion:
            data.nombre_servicio +
            (data.descripcion_servicio == "" || data.descripcion_servicio == null
                ? ""
                : " - " + data.descripcion_servicio),
        valor_unitario: 0,
        subtotal: 0,
        idProducto: "",
        idServicio: data.id,
        tipo: 0,
      });
      this.servicio = "";
    },
    eliminarDetalle(index) {
      this.detalleorden.splice(index, 1);
    },

    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").format("MMM Do YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    async getClientes() {
      this.arrayClientes = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "clientes/busqueda",
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arrayClientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getEgresos() {
      this.arrayEgresos = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "egresos/view_egresosy?id=" + this.idCaja,
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arrayEgresos = response.data.data;
        this.$v.$reset();
        this.validateSaldo = false;
        this.$bvModal.show("modalMostrarEgresos");
      } catch (error) {
        console.log(error);
      }
    },
    async getVentas() {
      this.arrayVentas = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "ventas/get_busqueda",
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arrayVentas = response.data.orden;
      } catch (error) {
        console.log(error);
      }
    },
    async getIdVenta() {
      this.arrayVentas = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL +
            "ventas/view_venta?id=" +
            this.$route.params.id,
            {
              headers: {"x-token": this.userT.token},
            }
        );
        // console.log(response.data.orden);
        this.formPro.venta = response.data.orden;
        this.selectVenta(response.data.orden);
        // this.arrayVentas = response.data.orden;
      } catch (error) {
        console.log(error);
      }
    },
    async getProductos(producto) {
      this.arrayProductos = [];
      if (producto == "" || producto == " ") {
        this.arrayProductos = [];
        return;
      } else {
        try {
          const response = await axios.get(
              process.env.VUE_APP_URL +
              `productos/nueva_busqueda?criterio=${this.busquedaLabel.value}&search=${producto}`,
              {
                headers: {"x-token": this.userT.token},
              }
          );
          this.arrayProductos = response.data.data;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getServicios(servicio) {
      this.arrayServicios = [];
      if (servicio == "" || servicio == " ") {
        return;
      } else {
        const response = await axios.get(
            process.env.VUE_APP_URL + `servicios/select?search=${servicio}`,
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arrayServicios = response.data.data;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal NIT-->
    <b-modal
        centered
        id="modalNIT"
        ref="modalNIT"
        title-class="text-black font-18"
        body-class="p-3"
        no-close-on-backdrop
        hide-header
    >
      <div v-if="!formFactura.validate">
        <h2>¿Desea facturar esta venta?</h2>
        <br/>
        <div class="row">
          <div v-if="formPro.total<=2500" class="col d-grid gap-2">
            <b-button variant="primary" @click="validateFacturar(2); "
            ><strong
            >Como CF&nbsp;&nbsp;<i
                class="bx bx-check"
            ></i></strong
            ></b-button>
          </div>
          <div class="col d-grid gap-2">
            <b-button variant="primary" @click="optionFacturar(1); validateNIT()"
            ><strong
            >Con NIT&nbsp;&nbsp;<i
                class="bx bx-check"
            ></i></strong
            ></b-button>
          </div>
          <div class="col d-grid gap-2">
            <b-button variant="primary" @click="optionFacturar(2)"
            ><strong
            >NO&nbsp;&nbsp;<i
                class="bx bx-trash"
            ></i></strong
            ></b-button>
          </div>
        </div>
      </div>

      <div v-else>
        <form>
          <div class="col-12 mb-3">
            <label>NIT</label>
            <input v-model="$v.formFactura.nit.$model" type="text"
                   class="form-control"
                   @keyup.enter="searchNIT()"
                   placeholder="Ingrese un nombre"
                   :class="{
                'is-invalid': $v.formFactura.nit.$error,
              }"
                   @input="$v.formFactura.nit.$touch()"/>
            <div
                v-if="
                $v.formFactura.nit.$error && !$v.formFactura.nit.required
              "
                class="invalid-feedback"
            >
              El NIT es necesario
            </div>
          </div>
          <div class="col-12 mb-3">
            <label>NOMBRE</label>
            <input v-model="formFactura.nombre" type="text"
                   disabled
                   class="form-control"
                   placeholder="Nombre"
            />
          </div>
          <div class="col-12 mb-3">
            <label>DIRECCIÓN</label>
            <input v-model="formFactura.direccion" type="text"
                   disabled
                   class="form-control"
                   placeholder="Dirección"
            />
          </div>
        </form>
      </div>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="validateFacturar()" v-if="formFactura.validate"
                  :disabled="formFactura.validateButton">Facturar
        </b-button>
        <b-button variant="danger" @click="$bvModal.hide('modalNIT')" v-if="formFactura.validate"
        >Cerrar
        </b-button
        >
      </template>
    </b-modal>

    <!-- Modal validacion caja -->
    <b-modal
        centered
        id="modalValidacion"
        title-class="text-black font-18"
        body-class="p-3"
        no-close-on-backdrop
        hide-footer
        hide-header
    >
      <h2>No se ha iniciado la caja</h2>
      <br/>
      <div class="row">
        <div class="col d-grid gap-2">
          <b-button variant="primary" @click="inicioRapido()"
          ><strong
          >INICIO DE CAJA RÁPIDO&nbsp;&nbsp;<i
              class="bx bx-edit"
          ></i></strong
          ></b-button>
        </div>
        <div class="col d-grid gap-2">
          <router-link :to="{ name: 'inicioCaja' }">
            <b-button variant="primary"
            ><strong
            >IR A REGISTROS DE CAJA&nbsp;&nbsp;<i
                class="bx bx-redo"
            ></i></strong
            ></b-button>
          </router-link>
        </div>
      </div>
      <template #modal-footer="{}"></template>
    </b-modal>

    <!-- Modal de Nuevo Cliente-->
    <b-modal
        centered
        @show="openModal('save')"
        @hidden="openModal('save')"
        v-model="showModalN"
        id="modalCliente"
        ref="modalCliente"
        title="Nuevo cliente"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
    >
      <form>
        <!-- Nombre -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Nombre</label>
            <input
                id="name"
                v-model="$v.formCliente.nombre.$model"
                type="text"
                class="form-control"
                placeholder="Ingrese un nombre"
                :class="{
                'is-invalid': $v.formCliente.nombre.$error,
              }"
                @input="$v.formCliente.nombre.$touch()"
            />
            <div
                v-if="
                $v.formCliente.nombre.$error && !$v.formCliente.nombre.required
              "
                class="invalid-feedback"
            >
              El nombre es obligatorio.
            </div>
          </div>
        </div>
        <!-- Identificacion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Identificación</label>
            <masked-input
                v-model.trim="formCliente.cui"
                :mask="[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]"
                class="form-control"
                placeholder="Ingrese CUI"
            />
          </div>
        </div>
        <!-- Nit -->
        <div class="col-12">
          <div class="mb-3">
            <label>Nit</label>
            <input
                v-model.trim="$v.formCliente.nit.$model"
                type="text"
                class="form-control"
                placeholder="Ingrese NIT"
            />
            <div class="alert alert-danger" v-if="!$v.formCliente.nit.nit">
              El número de NIT no es valido.
            </div>
          </div>
        </div>
        <!-- Telefono -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Teléfono</label>
            <masked-input
                v-model.trim="formCliente.telefono_proveedor"
                :class="{
                'is-invalid': $v.formCliente.telefono_proveedor.$error,
              }"
                :state="!$v.formCliente.telefono_proveedor.$error"
                :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                class="form-control"
                placeholder="Ingrese el número de teléfono"
            />
            <div
                :class="{
                'invalid-feedback': true,
                'd-block':
                  $v.formCliente.telefono_proveedor.$error &&
                  !$v.formCliente.telefono_proveedor.required,
              }"
            >
              Telefono Requerido
            </div>
          </div>
        </div>
        <!-- Direccion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Dirección del contacto</label>
            <input
                id="phone"
                v-model.trim="$v.formCliente.direccion.$model"
                type="text"
                class="form-control"
                placeholder="Ingrese Dirección"
            />
          </div>
        </div>
        <!-- Correo -->
        <div class="col-12">
          <div class="mb-3">
            <label for="correo">Correo</label>
            <input
                id="correo"
                v-model.trim="formCliente.correo"
                type="email"
                class="form-control"
                placeholder="Ingrese Correo"
            />
            <div
                class="alert alert-danger"
                v-if="!$v.formCliente.correo.correo"
            >
              El correo es inválido
            </div>
          </div>
        </div>
        <!-- Botones -->
        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
          >Cerrar
          </b-button
          >
          <b-button
              @click="validacionesCliente('save')"
              variant="success"
              class="ms-1"
          >Guardar
          </b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Modal productos -->
    <b-modal
        centered
        @show="openModal('productos')"
        @hidden="openModal('productos')"
        id="modalProductos"
        ref="modalProductos"
        title="Productos"
        size="lg"
        title-class="text-black font-18"
        body-class="p-3"
    >
      <b-form-group>
        <b-input-group>
          <b-dropdown variant="secondary" size="sm">
            <template v-slot:button-content>
              {{ busquedaLabel.nombre }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item
                v-for="(search, index) in busquedaTipos"
                :key="index"
                @click="cambiarTipo(search, 1)"
            >{{ search.nombre }}
            </b-dropdown-item
            >
          </b-dropdown>
          <b-input
              v-model="producto"
              placeholder="Ingrese el código o nombre del producto"
              @input="getProductos(producto)"
          >
          </b-input>
        </b-input-group>
      </b-form-group>

      <b-table stacked="lg" striped :items="arrayProductos" :fields="fieldsProductos">
        <template #cell(action)="data">
          <b-button
              v-if="verificarstock(data.item) != true"
              @click="agregarDetalle(data.item)"
              variant="outline-primary"
          ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
        <template #cell(producto)="data">
          <a
            :href="
              apiUrl + 'productos/get/imagen/' + data.item.Stock.imagen_stock
            " target="_blank"
          >
            {{ data.item.Stock.producto.nombre_producto }}
          </a>
        </template>
        <template #cell(codigo)="data">
          {{ data.item.Stock.codigo_stock }}
        </template>
        <template #cell(existencia)="data">
          {{ data.item.existencia_departamento }}
        </template>
        <template #cell(departamento)="data">
          {{ data.item.departamento.nombre_departamento }}
        </template>
        <template #cell(estante)="data">
          {{
            data.item.estante.nombre_estante == ""
                ? data.item.estante.nombre_pasillo
                : data.item.estante.nombre_estante
          }}
        </template>
        <template #cell(precio_venta)="data">
          {{ money(data.item.Stock.precio_venta_stock) }}
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalProductos')"
        >Cerrar
        </b-button
        >
      </template>
    </b-modal>

    <!-- Modal servicios -->
    <b-modal
        centered
        @show="openModal('servicios')"
        @hidden="openModal('servicios')"
        id="modalServicios"
        ref="modalServicios"
        title="Servicios"
        size="lg"
        title-class="text-black font-18"
        body-class="p-3"
    >
      <b-input
          v-model="servicio"
          placeholder="Ingrese el nombre del servicio"
          @input="getServicios(servicio)"
      >
      </b-input>
      <b-table stacked="lg" striped :items="arrayServicios" :fields="fieldsServicios">
        <template #cell(action)="data">
          <b-button
              v-if="verificarServicio(data.item) != true"
              @click="agregarDetalleServicio(data.item)"
              variant="outline-primary"
          ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalServicios')"
        >Cerrar
        </b-button
        >
      </template>
    </b-modal>

    <!-- Modal egresos -->
    <b-modal
        centered
        @show="openModal('egresos')"
        @hidden="openModal('egresos')"
        id="modalMostrarEgresos"
        ref="modalMostrarEgresos"
        :title="'Egresos ' + showDate(new Date())"
        size="lg"
        scrollable
        title-class="text-black font-18"
        body-class="p-3"
    >
      <div>
        <label>CANTIDAD</label>
        <input
            v-model.trim="$v.formEgreso.cantidad.$model"
            type="number"
            step="1"
            min="1"
            placeholder="Ingrese la cantidad a sacar"
            :class="{
            'is-invalid': $v.formEgreso.cantidad.$error || validateSaldo,
          }"
            class="form-control"
        />
        <div
            v-if="
                validateSaldo
              "
            class="invalid-feedback"
        >
          El saldo disponible es de Q.{{ saldoEgreso }}
        </div>
        <br/>
        <label>RAZÓN</label>
        <b-input
            :class="{
            'is-invalid': $v.formEgreso.razon.$error,
          }"
            v-model="formEgreso.razon"
            placeholder="Ingrese la razón del egreso"
        >
        </b-input>
        <br/>
        <div class="d-grid gap-2">
          <b-button variant="success" @click="validateSaldoEgreso">GUARDAR</b-button>
        </div>
      </div>
      <br/>

      <b-card v-b-toggle.accordion-1>
        <h3 align="left">
          <i class="fas fa-money-bill"></i>&nbsp;&nbsp;MOSTRAR EGRESOS
        </h3>
      </b-card>
      <b-collapse id="accordion-1">
        <table class="table">
          <thead>
          <tr>
            <th>ACCIONES</th>
            <th>CANTIDAD</th>
            <th>RAZÓN</th>
            <th>ESTADO</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, idx) in arrayEgresos" v-bind:key="idx">
            <td>
              <b-button-group>
                <b-button
                    v-if="item.estado_egreso"
                    size="md"
                    variant="outline-danger"
                    @click="eliminarDetalleEgreso(idx)"
                ><i :class="'bx bx-trash'"
                /></b-button>
              </b-button-group>
            </td>
            <td>
              <b-input
                  :disabled="true"
                  v-model="arrayEgresos[idx].monto"
                  @keyup.enter="editarDetalleEgreso(idx)"
              ></b-input>
            </td>
            <td>
              <b-input
                  :disabled="!item.estado_egreso"
                  v-model="arrayEgresos[idx].razon"
                  @keyup.enter="editarDetalleEgreso(idx)"
              ></b-input>
            </td>
            <td>
              <h5 v-if="item.estado_egreso == true">
                  <span class="badge bg-success ms-1"
                  ><strong>ACTIVO</strong></span
                  >
              </h5>
              <h5 v-else>
                  <span class="badge bg-danger ms-1"
                  ><strong>INACTIVO</strong></span
                  >
              </h5>
            </td>
          </tr>
          </tbody>
        </table>
      </b-collapse>

      <template #modal-footer="{}">
        <!-- <b-button variant="success" @click="saveEgreso">Guardar</b-button> -->
        <b-button variant="danger" @click="$bvModal.hide('modalMostrarEgresos')"
        >Cerrar
        </b-button
        >
      </template>
    </b-modal>

    <!-- Modal loading -->
    <b-modal
        centered
        v-model="showModalL"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        no-close-on-backdrop
        content-class="my-class"
        header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                  :animation-duration="2000"
                  :size="90"
                  color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center" style="min-height: 200px;">
                <div class="col-xl-12">
                  <div class="text-center">
                    <div class="mb-4">
                      <h2>PROCESAR VENTA</h2>
                    </div>
                  </div>
                  <div class="row" align="center">
                    <div class="col"/>
                    <div class="col-md-6">
                      <div>
                        <v-select
                        style="--vs-dropdown-max-height: 200px;"
                            v-model.trim="$v.formPro.venta.$model"
                            :state="!$v.formPro.venta.$error"
                            :options="arrayVentas"
                            @search="getVentas"
                            @input="selectVenta"
                            placeholder="Seleccionar venta..."
                            label="no_venta"
                        >
                          <template v-slot:option="option">
                            {{
                              `${option.no_venta} :: ${
                                  option.clienteId != null
                                      ? option.cliente.persona.nombre_persona
                                      : option.cliente_rapido
                              }`
                            }}
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            {{
                              `${option.no_venta} :: ${
                                  option.clienteId != null
                                      ? option.cliente.persona.nombre_persona
                                      : option.cliente_rapido
                              }`
                            }}
                          </template>
                        </v-select>
                        <div
                            :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.venta.$error &&
                              !$v.formPro.venta.required,
                          }"
                        >
                          Debe seleccionar un venta
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 d-grid gap-2">
                      <b-button
                          block
                          size="md"
                          variant="success"
                          @click="getEgresos(); getSaldo()"
                      >
                        MOSTRAR EGRESOS&nbsp;&nbsp;<i class="bx bx-grid"></i>
                      </b-button>
                      <!--                      <b-button-->
                      <!--                          block-->
                      <!--                          size="md"-->
                      <!--                          variant="success"-->
                      <!--                          v-b-modal.modalNIT-->
                      <!--                      >-->
                      <!--                        MODAL FACTURAR&nbsp;&nbsp;<i class="bx bx-grid"></i>-->
                      <!--                      </b-button>-->
                    </div>
                    <div class="col"/>
                  </div>
                  <hr/>
                  <div v-if="formPro.venta">
                    <div class="text-center">
                      <br/>
                      <div class="row">
                        <!-- Cliente-->
                        <div class="col">
                          <div>
                            <div class="row">
                              <div class="col">
                                <p class="text-muted mb-2">Cliente</p>
                              </div>
                            </div>
                            <div>
                              <v-select
                                  v-model.trim="$v.formPro.cliente.$model"
                                  :state="!$v.formPro.cliente.$error"
                                  :options="arrayCliente"
                                  @search="selectCliente"
                                  placeholder="Buscar cliente..."
                            
                                  label="nombre"
                              >
                                <template slot="no-options">
                                  <b-button
                                      block
                                      variant="primary"
                                      v-b-modal.modalCliente
                                  >Nuevo cliente
                                  </b-button
                                  >
                                </template>
                              </v-select>
                              <div
                                  :class="{
                                  'invalid-feedback': true,
                                  'd-block':
                                    $v.formPro.cliente.$error &&
                                    !$v.formPro.cliente.required,
                                }"
                              >
                                Debe seleccionar un cliente
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Sucursal -->
                        <div class="col">
                          <div class="mt-4 mt-sm-0">
                            <p class="text-muted mb-2">Sucursal</p>
                            <input
                                disabled
                                id="name"
                                v-model="$v.formPro.tienda.$model"
                                type="text"
                                class="form-control"
                                placeholder="Sin tienda"
                                :class="{
                                'is-invalid': $v.formPro.tienda.$error,
                              }"
                            />
                            <div
                                :class="{
                                'invalid-feedback': true,
                                'd-block':
                                  $v.formPro.tienda.$error &&
                                  !$v.formPro.tienda.required,
                              }"
                            >
                              Debe Registrar una tienda
                            </div>
                          </div>
                        </div>
                        <!-- Saldo -->
                        <div class="col">
                          <div class="d-grid">
                            <p class="text-muted mb-2">
                              {{
                                buttonSaldo == false
                                    ? "Saldo disponible"
                                    : "Saldo restante"
                              }}
                            </p>
                            <b-button
                                :disabled="temporal_saldo > 0 ? false : true"
                                :variant="
                                buttonSaldo == false ? 'info' : 'success'
                              "
                                block
                                @click="onActionClicked('saldo')"
                                size="md"
                            >{{
                                formatQuetzales(
                                    saldo_total > 0 ? saldo_total : 0.0
                                )
                              }}
                            </b-button
                            >
                          </div>
                        </div>
                        <!-- Fecha -->
                        <div class="col">
                          <div>
                            <p class="text-muted mb-2">Fecha venta</p>
                            <h3>
                              {{
                                formPro.fecha_venta == ""
                                    ? "Sin fecha"
                                    : showDate(new Date())
                              }}
                            </h3>
                          </div>
                        </div>
                        <!-- Total -->
                        <div class="col">
                          <div class="mt-4 mt-sm-0">
                            <p class="text-muted mb-2">Total</p>
                            {{ tomandototal() }}
                            <h3>
                              {{ formatQuetzales(calcularTotal) }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <br/>
                    </div>

                    <div class="row" v-if="detalleorden.length > 0">
                      <div class="col d-grid gap-2">
                        <b-button
                            block
                            size="lg"
                            variant="secondary"
                            v-b-modal.modalProductos
                        >
                          AGREGAR PRODUCTOS&nbsp;&nbsp;<i
                            class="bx bx-grid-alt"
                        ></i>
                        </b-button>
                      </div>
                      <!--                      <div class="col d-grid gap-2">-->
                      <!--                        <b-button-->
                      <!--                            block-->
                      <!--                            size="lg"-->
                      <!--                            variant="secondary"-->
                      <!--                            v-b-modal.modalServicios-->
                      <!--                        >-->
                      <!--                          AGREGAR SERVICIOS&nbsp;&nbsp;<i class="bx bx-car"></i>-->
                      <!--                        </b-button>-->
                      <!--                      </div>-->
                    </div>
                    <br/>

                    <div class="table-responsive">
                      <table class="table" border="2">
                        <thead>
                        <tr>
                          <th>ACCIONES</th>
                          <th>CANTIDAD</th>
                          <th>DESCRIPCIÓN</th>
                          <th>VALOR UNITARIO</th>
                          <th>SUB TOTAL</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(item, idx) in detalleorden"
                            v-bind:key="idx"
                        >
                          <td>
                            <b-button
                                class="icon-content col-xl-8 col-lg-4 col-sm-"
                                size="sm"
                                variant="outline-danger"
                                @click="eliminarDetalle(idx)"
                            >Eliminar&nbsp;&nbsp;<i :class="'bx bx-undo'"
                            /></b-button>
                          </td>
                          <td>
                            <div v-if="item.tipo == 1">
                              <b-input
                                  v-model="item.cantidad"
                                  @input="
                                    changeSubtotal(idx), validarExistencia(item)
                                  "
                              >
                              </b-input>
                              <p class="text-danger" v-show="item.existencia">
                                La cantidad sobrepasa a la existencia
                              </p>
                            </div>
                            <div v-else>
                              <b-input
                                  v-model="item.cantidad"
                                  @input="changeSubtotal(idx)"
                              >
                              </b-input>
                            </div>
                          </td>
                          <td> 
                            <a
                        :href="
                          apiUrl +
                          'productos/get/imagen/' +
                          item.imagen_stock
                        "
                        target="_blank"
                      >
                        {{item.descripcion }}
                      </a>
                            
                          </td>
                        
                          <td>
                            <b-input
                                disabled
                                v-model="item.valor_unitario"
                                @input="changeSubtotal(idx)"
                            >
                            </b-input>
                          </td>
                          <td>
                            {{ money(item.subtotal) }}
                          </td>
                        </tr>
                        <!-- <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <strong>TOTAL</strong>
                          </td>
                          <td>
                            <strong class="m-0">
                              {{
                                money(formPro.total > 0 ? formPro.total : 0.0)
                              }}
                            </strong>
                          </td>
                        </tr> -->
                        </tbody>
                      </table>
                    </div>

                    <!-- ESTOS TABS SON PARA EL DETALLE -->
                    <b-tabs
                        v-if="formPro.total > 0"
                        justified
                        nav-class="nav-tabs-custom"
                        content-class="text-muted"
                    >
                      <br/>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <h5><i class="bx bxs-folder-plus"></i></h5>
                          </span>
                          <h5>
                            <span class="d-none d-sm-inline-block">
                              <i class="bx bxs-folder-plus"></i>Métodos de
                              cobro</span
                            >
                          </h5>
                        </template>

                        <!-- Metodos de pago -->
                        <b-tabs pills vertical nav-wrapper-class="col-sm-4">
                          <!-- Efectivo -->
                          <b-tab :disabled="checkSelect.efectivo">
                            <template v-slot:title>
                              <b-form-checkbox v-model="checkMoney.efectivo">
                                &nbsp;&nbsp;<span
                                  class="d-none d-sm-inline-block"
                              >
                                  Efectivo</span
                              >&nbsp;
                                <i class="fas fa-money-bill"> </i>
                              </b-form-checkbox>
                            </template>

                            <b-card bg-variant="primary bg-soft">
                              <b-form-checkbox
                                  v-model="checkMoney.efectivo"
                                  @input="checkboxChange('efectivo')"
                              >&nbsp;&nbsp;Usar método de pago
                              </b-form-checkbox>
                              <br/>
                              <b-form-group label="MONTO">
                                <masked-input
                                    :disabled="!checkMoney.efectivo"
                                    v-model.trim="$v.cantidad_efectivo.$model"
                                    :mask="mask_quetzal"
                                    :guide="false"
                                    :keep-char-positions="true"
                                    :show-mask="true"
                                    type="text"
                                    @input="sumarCantidades()"
                                    placeholder="Ingresar el monto a pagar"
                                    :class="{
                                    'is-invalid': $v.cantidad_efectivo.$error,
                                  }"
                                    class="form-control"
                                />
                                <div
                                    v-if="checkMoney.efectivo"
                                    :class="{
                                    'invalid-feedback': true,
                                    'd-block':
                                      $v.cantidad_efectivo.$invalid &&
                                      !$v.cantidad_efectivo.$invalid.required,
                                  }"
                                >
                                  Debe ingresar el monto
                                </div>
                              </b-form-group>
                            </b-card>
                          </b-tab>
                          <!-- Transferencia -->
                          <b-tab :disabled="checkSelect.transferencia">
                            <template v-slot:title>
                              <b-form-checkbox
                                  v-model="checkMoney.transferencia"
                              >
                                &nbsp;&nbsp;<span
                                  class="d-none d-sm-inline-block"
                              >
                                  Transferencia</span
                              >&nbsp;
                                <i class="bx bx-transfer-alt"> </i>
                              </b-form-checkbox>
                            </template>

                            <b-card bg-variant="primary bg-soft">
                              <b-form-checkbox
                                  v-model="checkMoney.transferencia"
                                  @input="checkboxChange('transferencia')"
                              >&nbsp;&nbsp;Usar método de pago
                              </b-form-checkbox>
                              <br/>
                              <div
                                  v-for="(item, index) in transferencia"
                                  v-bind:key="index"
                              >
                                <b-form-group
                                    :label="
                                    'NÚMERO DE TRANSACCIÓN' + ' ' + (index + 1)
                                  "
                                    class="has-float-label"
                                >
                                  <b-input-group>
                                    <b-form-input
                                        :disabled="!checkMoney.transferencia"
                                        :class="{
                                        'is-invalid':
                                          $v.transferencia.$each.$iter[index]
                                            .transaccion_transferencia.$error,
                                      }"
                                        v-model.trim="
                                        item.transaccion_transferencia
                                      "
                                        placeholder="Ingresar en número de transacción"
                                        @input="sumarCantidades()"
                                    >
                                    </b-form-input>
                                    <b-input-group-append v-if="item.button">
                                      <b-button
                                          :disabled="!checkMoney.transferencia"
                                          variant="primary"
                                          @click="onButton('transferencia-plus')"
                                      ><i :class="'bx bx-plus-medical'"
                                      /></b-button>
                                    </b-input-group-append>
                                    <b-input-group-append v-if="!item.button">
                                      <b-button
                                          variant="primary"
                                          @click="
                                          onButton('transferencia-minus', index)
                                        "
                                      ><i :class="'bx bx-undo'"
                                      /></b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <div
                                      v-if="checkMoney.transferencia"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.transferencia.$each.$iter[index]
                                          .transaccion_transferencia.$invalid &&
                                        !$v.transferencia.$each.$iter[index]
                                          .transaccion_transferencia.$invalid
                                          .required,
                                    }"
                                  >
                                    Debe ingresar el número de transacción
                                  </div>
                                </b-form-group>
                                <br/>
                                <b-form-group label="MONTO">
                                  <masked-input
                                      :disabled="!checkMoney.transferencia"
                                      v-model.trim="item.cantidad_transferencia"
                                      :mask="mask_quetzal"
                                      :guide="false"
                                      :keep-char-positions="true"
                                      :show-mask="true"
                                      type="text"
                                      @input="sumarCantidades()"
                                      placeholder="Ingresar el monto a pagar"
                                      :class="{
                                      'is-invalid':
                                        $v.transferencia.$each.$iter[index]
                                          .cantidad_transferencia.$error,
                                    }"
                                      class="form-control"
                                  />
                                  <div
                                      v-if="checkMoney.transferencia"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.transferencia.$each.$iter[index]
                                          .cantidad_transferencia.$invalid &&
                                        !$v.transferencia.$each.$iter[index]
                                          .cantidad_transferencia.$invalid
                                          .required,
                                    }"
                                  >
                                    Debe ingresar el monto
                                  </div>
                                </b-form-group>
                                <hr/>
                              </div>
                            </b-card>
                          </b-tab>
                          <!-- Deposito -->
                          <b-tab :disabled="checkSelect.deposito">
                            <template v-slot:title>
                              <b-form-checkbox v-model="checkMoney.deposito">
                                &nbsp;&nbsp;<span
                                  class="d-none d-sm-inline-block"
                              >
                                  Deposito</span
                              >&nbsp;
                                <i class="bx bxs-downvote"> </i>
                              </b-form-checkbox>
                            </template>

                            <b-card bg-variant="primary bg-soft">
                              <b-form-checkbox
                                  v-model="checkMoney.deposito"
                                  @input="checkboxChange('deposito')"
                              >&nbsp;&nbsp;Usar método de pago
                              </b-form-checkbox>
                              <br/>
                              <div
                                  v-for="(item, index) in deposito"
                                  v-bind:key="index"
                              >
                                <b-form-group
                                    :label="
                                    'NÚMERO DE DEPOSITO' + ' ' + (index + 1)
                                  "
                                    class="has-float-label"
                                >
                                  <b-input-group>
                                    <b-form-input
                                        :disabled="!checkMoney.deposito"
                                        :class="{
                                        'is-invalid':
                                          $v.deposito.$each.$iter[index]
                                            .transaccion_deposito.$error,
                                      }"
                                        v-model.trim="item.transaccion_deposito"
                                        placeholder="Ingresar en número deposito"
                                        @input="sumarCantidades()"
                                    >
                                    </b-form-input>
                                    <b-input-group-append v-if="item.button">
                                      <b-button
                                          :disabled="!checkMoney.deposito"
                                          variant="primary"
                                          @click="onButton('deposito-plus')"
                                      ><i :class="'bx bx-plus-medical'"
                                      /></b-button>
                                    </b-input-group-append>
                                    <b-input-group-append v-if="!item.button">
                                      <b-button
                                          variant="primary"
                                          @click="
                                          onButton('deposito-minus', index)
                                        "
                                      ><i :class="'bx bx-undo'"
                                      /></b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <div
                                      v-if="checkMoney.deposito"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.deposito.$each.$iter[index]
                                          .transaccion_deposito.$invalid &&
                                        !$v.deposito.$each.$iter[index]
                                          .transaccion_deposito.$invalid
                                          .required,
                                    }"
                                  >
                                    Debe ingresar el número de deposito
                                  </div>
                                </b-form-group>
                                <br/>
                                <b-form-group label="MONTO">
                                  <masked-input
                                      :disabled="!checkMoney.deposito"
                                      v-model.trim="item.cantidad_deposito"
                                      :mask="mask_quetzal"
                                      :guide="false"
                                      :keep-char-positions="true"
                                      :show-mask="true"
                                      type="text"
                                      @input="sumarCantidades()"
                                      placeholder="Ingresar el monto a pagar"
                                      :class="{
                                      'is-invalid':
                                        $v.deposito.$each.$iter[index]
                                          .cantidad_deposito.$error,
                                    }"
                                      class="form-control"
                                  />
                                  <div
                                      v-if="checkMoney.deposito"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.deposito.$each.$iter[index]
                                          .cantidad_deposito.$invalid &&
                                        !$v.deposito.$each.$iter[index]
                                          .cantidad_deposito.$invalid.required,
                                    }"
                                  >
                                    Debe ingresar el monto
                                  </div>
                                </b-form-group>
                                <hr/>
                              </div>
                            </b-card>
                          </b-tab>
                          <!-- Cheque -->
                          <b-tab :disabled="checkSelect.cheque">
                            <template v-slot:title>
                              <b-form-checkbox v-model="checkMoney.cheque">
                                &nbsp;&nbsp;<span
                                  class="d-none d-sm-inline-block"
                              >
                                  Cheque</span
                              >&nbsp;
                                <i class="bx bx-dock-top"> </i>
                              </b-form-checkbox>
                            </template>

                            <b-card bg-variant="primary bg-soft">
                              <b-form-checkbox
                                  v-model="checkMoney.cheque"
                                  @input="checkboxChange('cheque')"
                              >&nbsp;&nbsp;Usar método de pago
                              </b-form-checkbox>
                              <br/>
                              <div
                                  v-for="(item, index) in cheque"
                                  v-bind:key="index"
                              >
                                <b-form-group
                                    :label="
                                    'NÚMERO DE CHEQUE' + ' ' + (index + 1)
                                  "
                                    class="has-float-label"
                                >
                                  <b-input-group>
                                    <b-form-input
                                        :disabled="!checkMoney.cheque"
                                        :class="{
                                        'is-invalid':
                                          $v.cheque.$each.$iter[index]
                                            .transaccion_cheque.$error,
                                      }"
                                        v-model.trim="item.transaccion_cheque"
                                        placeholder="Ingresar en número dcheque"
                                        @input="sumarCantidades()"
                                    >
                                    </b-form-input>
                                    <b-input-group-append v-if="item.button">
                                      <b-button
                                          :disabled="!checkMoney.cheque"
                                          variant="primary"
                                          @click="onButton('cheque-plus')"
                                      ><i :class="'bx bx-plus-medical'"
                                      /></b-button>
                                    </b-input-group-append>
                                    <b-input-group-append v-if="!item.button">
                                      <b-button
                                          variant="primary"
                                          @click="onButton('cheque-minus', index)"
                                      ><i :class="'bx bx-undo'"
                                      /></b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <div
                                      v-if="checkMoney.cheque"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.cheque.$each.$iter[index]
                                          .transaccion_cheque.$invalid &&
                                        !$v.cheque.$each.$iter[index]
                                          .transaccion_cheque.$invalid.required,
                                    }"
                                  >
                                    Debe ingresar el número dcheque
                                  </div>
                                </b-form-group>
                                <br/>
                                <b-form-group label="MONTO">
                                  <masked-input
                                      :disabled="!checkMoney.cheque"
                                      v-model.trim="item.cantidad_cheque"
                                      :mask="mask_quetzal"
                                      :guide="false"
                                      :keep-char-positions="true"
                                      :show-mask="true"
                                      type="text"
                                      @input="sumarCantidades()"
                                      placeholder="Ingresar el monto a pagar"
                                      :class="{
                                      'is-invalid':
                                        $v.cheque.$each.$iter[index]
                                          .cantidad_cheque.$error,
                                    }"
                                      class="form-control"
                                  />
                                  <div
                                      v-if="checkMoney.cheque"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.cheque.$each.$iter[index]
                                          .cantidad_cheque.$invalid &&
                                        !$v.cheque.$each.$iter[index]
                                          .cantidad_cheque.$invalid.required,
                                    }"
                                  >
                                    Debe ingresar el monto
                                  </div>
                                </b-form-group>
                                <hr/>
                              </div>
                            </b-card>
                          </b-tab>
                          <!-- Tarjeta -->
                          <b-tab :disabled="checkSelect.tarjeta">
                            <template v-slot:title>
                              <b-form-checkbox v-model="checkMoney.tarjeta">
                                &nbsp;&nbsp;<span
                                  class="d-none d-sm-inline-block"
                              >
                                  Tarjeta</span
                              >&nbsp;
                                <i class="far fa-credit-card"> </i>
                              </b-form-checkbox>
                            </template>

                            <b-card bg-variant="primary bg-soft">
                              <b-form-checkbox
                                  v-model="checkMoney.tarjeta"
                                  @input="checkboxChange('tarjeta')"
                              >&nbsp;&nbsp;Usar método de pago
                              </b-form-checkbox>
                              <br/>
                              <div
                                  v-for="(item, index) in tarjeta"
                                  v-bind:key="index"
                              >
                                <b-form-group
                                    :label="
                                    'NÚMERO DE TRANSACCIÓN TARJETA' +
                                    ' ' +
                                    (index + 1)
                                  "
                                    class="has-float-label"
                                >
                                  <b-input-group>
                                    <b-form-input
                                        :disabled="!checkMoney.tarjeta"
                                        :class="{
                                        'is-invalid':
                                          $v.tarjeta.$each.$iter[index]
                                            .transaccion_tarjeta.$error,
                                      }"
                                        v-model.trim="item.transaccion_tarjeta"
                                        placeholder="Ingresar en número tarjeta"
                                        @input="sumarCantidades()"
                                    >
                                    </b-form-input>
                                    <b-input-group-append v-if="item.button">
                                      <b-button
                                          :disabled="!checkMoney.tarjeta"
                                          variant="primary"
                                          @click="onButton('tarjeta-plus')"
                                      ><i :class="'bx bx-plus-medical'"
                                      /></b-button>
                                    </b-input-group-append>
                                    <b-input-group-append v-if="!item.button">
                                      <b-button
                                          variant="primary"
                                          @click="
                                          onButton('tarjeta-minus', index)
                                        "
                                      ><i :class="'bx bx-undo'"
                                      /></b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                  <div
                                      v-if="checkMoney.tarjeta"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.tarjeta.$each.$iter[index]
                                          .transaccion_tarjeta.$invalid &&
                                        !$v.tarjeta.$each.$iter[index]
                                          .transaccion_tarjeta.$invalid
                                          .required,
                                    }"
                                  >
                                    Debe ingresar el número de transacción de
                                    tarjeta
                                  </div>
                                </b-form-group>
                                <br/>
                                <b-form-group label="MONTO">
                                  <masked-input
                                      :disabled="!checkMoney.tarjeta"
                                      v-model.trim="item.cantidad_tarjeta"
                                      :mask="mask_quetzal"
                                      :guide="false"
                                      :keep-char-positions="true"
                                      :show-mask="true"
                                      type="text"
                                      @input="sumarCantidades()"
                                      placeholder="Ingresar el monto a pagar"
                                      :class="{
                                      'is-invalid':
                                        $v.tarjeta.$each.$iter[index]
                                          .cantidad_tarjeta.$error,
                                    }"
                                      class="form-control"
                                  />
                                  <div
                                      v-if="checkMoney.tarjeta"
                                      :class="{
                                      'invalid-feedback': true,
                                      'd-block':
                                        $v.tarjeta.$each.$iter[index]
                                          .cantidad_tarjeta.$invalid &&
                                        !$v.tarjeta.$each.$iter[index]
                                          .cantidad_tarjeta.$invalid.required,
                                    }"
                                  >
                                    Debe ingresar el monto
                                  </div>
                                </b-form-group>
                                <hr/>
                              </div>
                            </b-card>
                          </b-tab>
                        </b-tabs>
                        <br/>
                        <div class="row">
                          <div class="col">
                            <b-card
                                bg-variant="primary"
                                class="text-white-50 bg-gradient"
                            >
                              <h2 class="mt-0 mb-4 text-white">
                                <i class="bx bx-money me-3"></i> Total a pagar
                              </h2>
                              <h3 class="mt-0 mb-4 text-white" align="center">
                                {{
                                  money(formPro.total > 0 ? formPro.total : 0.0)
                                }}
                              </h3>
                            </b-card>
                          </div>
                          <div class="col">
                            <b-card
                                bg-variant="primary"
                                class="text-white-50 bg-gradient"
                            >
                              <h2 class="mt-0 mb-4 text-white">
                                <i class="bx bx-list-check me-3"></i> Restante
                                de pago
                              </h2>
                              <h3 class="mt-0 mb-4 text-white" align="center">
                                {{
                                  money(
                                      formPro.total > 0
                                          ? formPro.total - montoFinal.cantidad
                                          : 0.0
                                  )
                                }}
                              </h3>
                            </b-card>
                          </div>
                          <div class="col">
                            <b-card
                                bg-variant="primary"
                                class="text-white-50 bg-gradient"
                            >
                              <h2 class="mt-0 mb-4 text-white">
                                <i class="bx bx-detail me-3"></i> Cantidad
                                pagando
                              </h2>
                              <h3 class="mt-0 mb-4 text-white" align="center">
                                {{
                                  money(
                                      montoFinal.cantidad >= 0
                                          ? montoFinal.cantidad
                                          : 0.0
                                  )
                                }}
                              </h3>
                            </b-card>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                    <div class="row">
                      <div class="col d-grid gap-2">
                        <b-button
                            block
                            size="lg"
                            variant="outline-success"
                            class="btn btn-rounded mb-2 me-2"
                            @click="validacionesVenta()"
                        >
                          <!-- {{ tomandototal() }} -->
                          <i class="bx bx-repeat"></i>
                          &nbsp;&nbsp;<b>GUARDAR</b>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- end row -->
  </Layout>
</template>